// =====================================================
// BUYERVISITREQUESTS.JSX  (updated upcoming card only)
// Changes:
//   1. Mark as Complete button added alongside Send Greetings
//   2. Status badge updates live on mark complete
// =====================================================

import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaStar, FaMapMarkerAlt, FaCheckCircle,
  FaHome, FaCalendarAlt, FaHeadset
} from 'react-icons/fa';
import { FiCheckCircle } from 'react-icons/fi';
import '../../../assets/css/Buyer/dashboard/buyerreq/buyerrequest.css';
import BuyerMasterLayout from 'layouts/BuyerMasterLayout';
import axios from 'axios';
import AppContext from 'context/AppContext';
import { Button } from 'react-bootstrap';


export default function BuyerRequest() {
  const navigate = useNavigate();
  const [upcomingRequests, setUpcomingRequests] = useState([]);
  const { baseUrl, baseUrlForFiles, loggedInBuyer,authToken } = useContext(AppContext);
  const [activeTab, setActiveTab] = useState('upcoming');
  const [requests, setRequests] = useState([]);
  const [toast, setToast] = useState({ show: false, msg: '', type: '' });
  const [loading, setLoading] = useState(true);

  // ── Submit rating ──────────────────────────────────────────
  const submitRating = (requestId) => {
    const request = requests.find(r => r.id === requestId);
    if (!request || request.rating === 0) { alert('Please select rating first'); return; }

    const formData = new FormData();
    formData.append('exbuyer_id', loggedInBuyer?.id);
    formData.append('exproperty_id', request.exproperty?.id);
    formData.append('exvisitrequest_id', request.id);
    formData.append('rating', request.rating);
    formData.append('comment', request.feedback);
    formData.append('status', 'completed');

    axios.post(`${baseUrl}/buyer/rating/submitRating`, formData,{
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
      }
      )
      .then(res => { if (res.data.success) 
        
        fetchCompletedRequests(); })
      .catch(err => { console.error(err); alert('Server error'); });
  };

  // ── Fetch completed ────────────────────────────────────────
  const fetchCompletedRequests = () => {
    const formData = new FormData();
    formData.append('exbuyer_id', loggedInBuyer?.id);
    axios.post(`${baseUrl}/buyer/rating/viewCompletedVisitRequests`, formData,{
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
      }
      )
      .then(res => {
        console.log("Completed Requests:", res.data);
        setRequests(res.data.completedRequests || [])
  }) .catch(err => console.error(err));
  };

  // ── Fetch upcoming ─────────────────────────────────────────
  const fetchUpcomingRequests = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('exbuyer_id', loggedInBuyer?.id);
    axios.post(`${baseUrl}/buyer/visitrequest/viewUpcomingVisitRequests`, formData,{
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
      }
      )
      .then(res => { 
        console.log("Upcoming Requests:", res.data);
        setUpcomingRequests(res.data.upcomingRequests || []); setLoading(false); })
      .catch(err => { console.error(err); setLoading(false); });
  };

  useEffect(() => { fetchCompletedRequests(); }, []);
  useEffect(() => { fetchUpcomingRequests(); }, []);

  // ── Send greetings ─────────────────────────────────────────
  const sendGreetings = (propertyid, sellerId) => {
    const formData = new FormData();
    formData.append('exbuyer_id', loggedInBuyer.id);
    formData.append('exproperty_id', propertyid);
    formData.append('exseller_id', sellerId);
    axios.post(`${baseUrl}/buyer/visitrequest/sendGreetings`, formData,{
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
      }
      )
      .then(res => console.log(res.data))
      .catch(err => console.error(err));
  };

  // ── Mark as Complete (local + API) ─────────────────────────
  const markAsComplete = (requestId) => {
    const formData = new FormData();
    formData.append("exbuyer_id", loggedInBuyer?.id);
    formData.append("exvisitrequest_id", requestId);
    axios.post(
      `${baseUrl}/buyer/visitrequest/markAsComplete`, formData, {
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
      }
      )
      .then((res) => {
        if (res.data.success) {
          console.log("Conversion Rate:", res.data.conversion_rate);
          fetchUpcomingRequests();
          fetchCompletedRequests();
          showToast("Visit Completed Successfully");
        } else {
          alert(res.data.message);
        }
      })
      .catch(err => console.log(err));
  };

  // ── Restore ratings from localStorage ─────────────────────
  useEffect(() => {
    const saved = localStorage.getItem('buyerPropertyRatings');
    if (saved) {
      try {
        const ratings = JSON.parse(saved);
        setRequests(prev => prev.map(req => {
          const existing = ratings.find(r => r.id === req.id);
          return existing ? { ...req, ...existing } : req;
        }));
      } catch (_) { }
    }
  }, []);

  // ── Toast helper ───────────────────────────────────────────
  const showToast = (msg, type = 'success') => {
    setToast({ show: true, msg, type });
    setTimeout(() => setToast({ show: false, msg: '', type: '' }), 3000);
  };

  // ── Star / feedback handlers ───────────────────────────────
  const handleStarClick = (requestId, starIndex) =>
    setRequests(prev => prev.map(r => r.id === requestId ? { ...r, rating: starIndex + 1 } : r));

  const handleFeedbackChange = (requestId, value) =>
    setRequests(prev => prev.map(r => r.id === requestId ? { ...r, feedback: value } : r));

  const handleSubmitRating = (requestId) => {
    const request = requests.find(r => r.id === requestId);
    if (!request || request.rating === 0) { showToast('⚠️ Please select a rating', 'error'); return; }
    const updated = requests.map(r => r.id === requestId ? { ...r, submitted: true } : r);
    setRequests(updated);
    localStorage.setItem('buyerPropertyRatings', JSON.stringify(updated));
    showToast('✅ Rating submitted successfully!', 'success');
  };

  const goToProperty = (propertyId) => navigate(`/buyer/property/${propertyId}`);

  // ─────────────────────────────────────────
  //  RENDER COMPLETED CARD  (unchanged)
  // ─────────────────────────────────────────
  const renderCompletedCard = (req) => {
    const stars = [0, 1, 2, 3, 4];
    return (
      <div key={req.id} className="buyerreq-card">
        <div className="buyerreq-card-header">
          <div>
            <div className="buyerreq-card-title">{req.exproperty?.property_title}</div>
            <div className="buyerreq-card-location"><FaMapMarkerAlt /> {req.exproperty?.location}</div>
          </div>
          <div className="buyerreq-card-meta">
            <div className="buyerreq-card-date">Visited on {req.bookingDate}</div>
            <span className={`buyerreq-card-status ${req.status}`}>
              {req.status.charAt(0).toUpperCase() + req.status.slice(1)}
            </span>
          </div>
        </div>

        <div className="buyerreq-card-body">
          <div className="buyerreq-card-img-wrap" onClick={() => goToProperty(req.propertyId)}>
            <img src={`${baseUrlForFiles}/${req.exproperty?.expropertyimages[0].images}`} alt={req.title} className="buyerreq-card-img" />
          </div>

          <div className="buyerreq-rating-section">
            {req.submitted ? (
              <div className="buyerreq-success-pill"><FaCheckCircle /> Rating Submitted</div>
            ) : (
              <>
                <div className="buyerreq-status-label">Visit Completed</div>
                <div className="buyerreq-stars">
                  {stars.map(index => (
                    <button key={index}
                      className={`buyerreq-star ${index < (req.exratings?.[0]?.rating || 0) ? 'filled' : ''}`}
                      onClick={() => handleStarClick(req.id, index)}>
                      <FaStar />
                    </button>
                  ))}
                </div>
                {req.rating > 0 && (
                  <div className="buyerreq-feedback">
                    <textarea className="buyerreq-feedback-textarea"
                      placeholder="Share your experience (optional)..."
                      value={req.feedback}
                      onChange={(e) => handleFeedbackChange(req.id, e.target.value)}
                      rows={3} />
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {!req.submitted && req.rating > 0 && (
          <button className="buyerreq-submit-btn" onClick={() => submitRating(req.id)}>
            Submit Rating
          </button>
        )}
      </div>
    );
  };

  // ─────────────────────────────────────────
  //  RENDER UPCOMING CARD  ← UPDATED
  // ─────────────────────────────────────────
  const renderUpcomingCard = (req) => {
    const isCompleted = req.status === "completed";

    return (
      <div key={req.id} className="buyerreq-card">

        {/* Header — status badge updates live */}
        <div className="buyerreq-card-header">
          <div>
            <div className="buyerreq-card-title">{req.exproperty?.property_title}</div>
            <div className="buyerreq-card-location"><FaMapMarkerAlt /> {req.exproperty?.location}</div>
          </div>
          <div className="buyerreq-card-meta">
            <div className="buyerreq-card-date">Scheduled: {req.bookingDate}</div>

            {/* ── Dynamic status badge with smooth transition ── */}
            <span className={`buyerreq-card-status completed buyerreq-status--animated`}>
              {req.status.charAt(0).toUpperCase() + req.status.slice(1)}
            </span>
          </div>
        </div>

        {/* Body */}
        <div className="buyerreq-card-body">
          <div className="buyerreq-card-img-wrap" onClick={() => goToProperty(req.exproperty?.id)}>
            <img
              src={`${baseUrlForFiles}/${req.exproperty?.expropertyimages[0].images}`}
              alt={req.exproperty?.property_title}
              className="buyerreq-card-img"
            />
          </div>

          <div className="buyerreq-rating-section">
            <div style={{ color: 'var(--text-secondary)', fontSize: 'var(--font-size-sm)', marginBottom: 12 }}>
              {req.exproperty?.description}
            </div>

            {/* ── Action buttons row ── */}
            <div className="buyerreq-action-row">

              {/* Send Greetings */}
              <button
                className="buyerreq-greet-btn"
                disabled={isCompleted}
                onClick={() => sendGreetings(req.exproperty?.id, req.exseller?.id)}
              >
                👋 Send Greetings
              </button>

              {/* Mark as Complete */}
              {isCompleted ? (
                <div className="buyerreq-success-pill buyerreq-complete-pill">
                  <FiCheckCircle /> Visit Completed
                </div>
              ) : (

                <button
                  className="buyerreq-complete-btn"
                  onClick={() => markAsComplete(req.id)}
                  disabled={req.status !== "accepted"}
                >
                  <FiCheckCircle size={14} />
                  Mark as Complete
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // ─────────────────────────────────────────
  //  MAIN RENDER
  // ─────────────────────────────────────────
  return (
    <BuyerMasterLayout pageTitle="visit request">
       {loading ? (

      <div className="buyerreq-loading">
        <div className="buyerreq-loader-spinner"></div>

        <p>Loading visit requests...</p>
      </div>

    ) : (
      <div className="buyerreq-page">

        {/* Tabs */}
        <div className="buyerreq-tabs">
          <button className={`buyerreq-tab ${activeTab === 'upcoming' ? 'active' : ''}`} onClick={() => setActiveTab('upcoming')}>Upcoming Requests</button>
          <button className={`buyerreq-tab ${activeTab === 'completed' ? 'active' : ''}`} onClick={() => setActiveTab('completed')}>Completed Requests</button>
        </div>

        {/* List */}
        <div className="buyerreq-list">
          {activeTab === 'completed' ? (
            requests.length > 0 ? requests.map(renderCompletedCard) : (
              <div className="buyerreq-empty">
                <span className="buyerreq-empty-icon">📋</span>
                <div className="buyerreq-empty-title">No Completed Visits Yet</div>
                <div className="buyerreq-empty-text">Once you complete a property visit, you'll be able to rate it here.</div>
                <button className="buyerreq-empty-btn" onClick={() => navigate('/buyer/properties')}>Browse Properties</button>
              </div>
            )
          ) : (
            upcomingRequests.length > 0 ? upcomingRequests.map(renderUpcomingCard) : (
              <div className="buyerreq-empty">
                <span className="buyerreq-empty-icon">📅</span>
                <div className="buyerreq-empty-title">No Upcoming Visits</div>
                <div className="buyerreq-empty-text">Schedule a property visit to see it here.</div>
                <button className="buyerreq-empty-btn" onClick={() => navigate('/buyer/properties')}>Schedule a Visit</button>
              </div>
            )
          )}
        </div>

        {/* Toast */}
        <div className={`buyerreq-toast ${toast.show ? 'show' : ''} ${toast.type}`}>{toast.msg}</div>

      </div>
          )}
    </BuyerMasterLayout>
  );
}